"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadAttachment = exports.uploadProfileAvatar = exports.uploadServiceLogo = exports.uploadCompanyLogo = exports.uploadLogo = exports.uploadFileAndGetUrl = void 0;
var end2end_1 = require("@hudled/end2end");
var firebaseConf_1 = require("utils/firebaseConf");
var fieldProcessors_1 = require("../fieldProcessors");
var storageRef = firebaseConf_1.storage.ref();
var uploadFileAndGetUrl = function (path, file) { return __awaiter(void 0, void 0, void 0, function () {
    var avatarRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                avatarRef = storageRef.child(path);
                return [4 /*yield*/, avatarRef.put(file)];
            case 1:
                _a.sent();
                return [2 /*return*/, avatarRef.getDownloadURL()];
        }
    });
}); };
exports.uploadFileAndGetUrl = uploadFileAndGetUrl;
var uploadLogo = function (folder, prefix) { return function (brand, file, uid) { return __awaiter(void 0, void 0, void 0, function () {
    var valuesToSave, idx, logoName, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                valuesToSave = {};
                idx = brand.logoNr ? brand.logoNr + 1 : 1;
                logoName = "".concat(prefix, "_").concat(brand.id, "__").concat(idx);
                _a = valuesToSave;
                return [4 /*yield*/, (0, exports.uploadFileAndGetUrl)("images/logos/".concat(uid, "/").concat(folder, "/").concat(logoName), file)];
            case 1:
                _a.logoUrl = _b.sent();
                valuesToSave.logoNr = idx;
                valuesToSave.logoExt = (0, end2end_1.mimeToExtension)(file.type);
                return [2 /*return*/, valuesToSave];
        }
    });
}); }; };
exports.uploadLogo = uploadLogo;
exports.uploadCompanyLogo = (0, exports.uploadLogo)('companies', 'cmpny');
exports.uploadServiceLogo = (0, exports.uploadLogo)('services', 'srv');
var uploadProfileAvatar = function (profile, file) { return __awaiter(void 0, void 0, void 0, function () {
    var valuesToSave, idx, avatarName, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                valuesToSave = {};
                idx = profile.avatarNr ? profile.avatarNr + 1 : 1;
                avatarName = "usr_".concat(profile.id, "__").concat(idx);
                _a = valuesToSave;
                return [4 /*yield*/, (0, exports.uploadFileAndGetUrl)("images/avatars/".concat(profile.id, "/").concat(avatarName), file)];
            case 1:
                _a.avatarUrl = _b.sent();
                valuesToSave.avatarNr = idx;
                return [2 /*return*/, valuesToSave];
        }
    });
}); };
exports.uploadProfileAvatar = uploadProfileAvatar;
var downloadAttachment = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var downloadUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, storageRef.child(url).getDownloadURL()];
            case 1:
                downloadUrl = _a.sent();
                (0, fieldProcessors_1.download)(downloadUrl);
                return [2 /*return*/];
        }
    });
}); };
exports.downloadAttachment = downloadAttachment;
